import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import dltFormRoute from './dlt-form-route';


const JourneyRequestsListPage = lazy(() => import('../components/JourneyRequestsListPage'));

const NewJourneyRequestPage = lazy(() => import('../components/JourneyRequestsPage'));
const DLTForm = lazy(() => import('../components/DLTForm/DLTForm'));

const JourneyRequestsRoutes: RouteObject[] = [
  {
    path: 'journeys/requests/new',
    element: <NewJourneyRequestPage />,
  },
  {
    path: 'journeys/requests/:requestId/dlt-form',
    element: <DLTForm />,
  },
  {
    path: 'journeys/requests',
    element: <JourneyRequestsListPage />,
  },
];

export const DLTFormRoute: RouteObject = dltFormRoute;

export default JourneyRequestsRoutes;
